import { render, staticRenderFns } from "./BetListDialog.vue?vue&type=template&id=189ed6b7&scoped=true"
import script from "./BetListDialog.vue?vue&type=script&lang=js"
export * from "./BetListDialog.vue?vue&type=script&lang=js"
import style0 from "./BetListDialog.vue?vue&type=style&index=0&id=189ed6b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ed6b7",
  null
  
)

export default component.exports